const { CarouselElement } = window.BAO.Carousel
const { useAutoplay } = window.BAO.Carousel.plugins

export class AnnoucementBarCarousel extends CarouselElement {
  static get requiredElements () {
    return []
  }

  async connectedCallback () {
    super.connectedCallback()

    this.setupListeners()
  }

  setupListeners () {
    if (this.els?.dropdownclose?.exists === true) {
      this.els.dropdownclose.elements.forEach(element => {
        element.addEventListener('click', this.closeDropdown.bind(this))
      })
    }
    if (this.externalEls?.dropdownclose?.exists === true) {
      this.externalEls.dropdownclose.element.addEventListener(
        'click',
        this.closeDropdown.bind(this),
      )
    }

    if (this.els?.dropdownopen?.exists === true) {
      this.els.dropdownopen.elements.forEach(element => {
        element.addEventListener('click', this.openDropdown.bind(this))
      })
    }
  }

  openDropdown (e) {
    document.body.classList.add('hd-AnnouncementBar_Dropdown-active')

    const parentAnnouncement = e.target.closest(
      '.hd-AnnouncementBar_Announcement-hasDropdown',
    )
    if (parentAnnouncement) {
      parentAnnouncement.classList.add(
        'hd-AnnouncementBar_Announcement-openDropdown',
      )
    }
  }

  closeDropdown (e) {
    document.body.classList.remove('hd-AnnouncementBar_Dropdown-active')

    const openDropdown = document.querySelector(
      '.hd-AnnouncementBar_Announcement-openDropdown',
    )
    if (openDropdown) {
      openDropdown.classList.remove(
        'hd-AnnouncementBar_Announcement-openDropdown',
      )
    }
  }

  async initialiseCarousel () {
    if (this.els?.slider?.element == null) return

    this.carousel = await super.initialiseCarousel()
  }

  /** @returns {KeenSliderOptions} */
  get options () {
    return {
      slides: {
        perView: 1,
        spacing: 0,
      },
      loop: true,
      drag: false,
      defaultAnimation: {
        duration: this.durationOfFade,
      },
      detailsChanged: carousel => {
        carousel.slides.forEach((element, idx) => {
          element.style.opacity = carousel.track.details.slides[idx].portion
          const isVisible = idx === carousel.track.details.rel
          element.style.visibility = isVisible ? 'visible' : 'hidden'
        })
      },
      renderMode: 'custom',
      created: carousel => {
        const slider = carousel.container
        slider.setAttribute(`data-initialised`, true)
        setTimeout(() => {
          const slideWithCountdown = carousel.slides.find(slide =>
            slide.classList.contains(
              'hd-AnnouncementBar_Announcement-countdown',
            ),
          )
          slideWithCountdown
            ? (slideWithCountdown.style.position = 'relative')
            : (carousel.slides[0].style.position = 'relative')
        }, 1000)

        const highest = Math.max(
          ...carousel.slides.map(item => item.getBoundingClientRect().height),
        )

        carousel.container.style.height = `${highest}px`
      },
    }
  }

  /** @returns {KeenSliderPlugin[]} */
  get plugins () {
    return [useAutoplay(this.durationTillFade, { pauseOnHover: false })]
  }

  get durationTillFade () {
    return Number(this.dataset.durationTillFade) || 5
  }

  get durationOfFade () {
    return Number(this.dataset.durationOfFade * 100) || 500
  }
}

if (!customElements.get('annoucement-bar')) {
  customElements.define('annoucement-bar', AnnoucementBarCarousel)
}
